import React, { memo } from 'react'

const CountdownStatus = ({ status }) => {
    return <div style={{ color: status ? 'green' : 'gray' }}>{status ? 'แสดงเวลานับถอยหลัง' : 'ไม่แสดงเวลานับถอยหลัง'}</div>
}

export default memo(CountdownStatus)